import { useAtomValue } from "jotai";
import { questionnaireAddressSyncConfigAtom } from "../state/questionnaireAddressSyncConfigAtom";
import type { AddressSyncConfig } from "../types";

/**
 * Get address sync configuration from questionnaire state.
 * Returns undefined if no custom config is set (defaults will be used).
 *
 * @example const addressSyncConfig = useAddressSyncConfig();
 */
export function useAddressSyncConfig(): AddressSyncConfig | undefined {
  return useAtomValue(questionnaireAddressSyncConfigAtom);
}
